// frontend/src/components/RateLimitWarning.js
import React, { useState, useEffect } from 'react';

/**
 * Muestra un contador regresivo cuando se alcanza el límite de tasa.
 * @param {number} resetTime - Timestamp (ms) cuando se reinicia el límite.
 * @param {function} onReset - Callback opcional al finalizar.
 */
const RateLimitWarning = ({ resetTime, onReset }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!resetTime) return;

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = resetTime - now;

      if (diff <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
        if (onReset) onReset();
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    // Initial calc
    const now = Date.now();
    const diff = resetTime - now;
    if (diff > 0) setTimeLeft(diff);

    return () => clearInterval(interval);
  }, [resetTime, onReset]);

  if (timeLeft <= 0) return null;

  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    <div className="rate-limit-warning" style={{
      backgroundColor: '#fff3cd',
      color: '#856404',
      border: '1px solid #ffeeba',
      padding: '10px',
      borderRadius: '5px',
      marginTop: '10px',
      marginBottom: '10px',
      textAlign: 'center'
    }}>
      <strong>⚠️ Límite de IA alcanzado.</strong>
      <div>
        Podrás generar más contenido en:
        <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>
          {minutes}:{seconds.toString().padStart(2, '0')}
        </span>
      </div>
    </div>
  );
};

export default RateLimitWarning;
